import { Record } from 'immutable';
import ContentType from '../ContentType';

const RelationshipRecord = Record({
  id: null,
  name: null,
  system: null,
  created: null,
  updated: null,
  comments: [],
});

class Relationship extends RelationshipRecord {
  static contentType = ContentType.IPRESOURCE;

  get getId() {
    return this.get('id');
  }
}

export default Relationship;
